const jsonToCsv = (data, headers = null) => {
    if (!data.length) return "";
    const headersKeys = headers ? headers.map(header => header.id) : Object.keys(data[0]);
    const headersTitles = headers ? headers.map(header => header.title) : headersKeys;
    console.log(headersTitles);
    console.log(headersKeys);
    return [headersTitles.join(","), ...data.map(row =>
        headersKeys.map(field => `"${row[field] ?? ""}"`).join(",")
      )].join("\n");
}


const downloadCsv = (csv, filename = "data.csv") => {
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.setAttribute("download", filename);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}

const formatHolidays = (holidayData, holidays) => {
    // Check for "No Holiday" marker
    if (holidayData === "NO_HOLIDAY" || holidayData === "-1" || holidayData === -1) {
        return "No Holiday";
    }
    
    if (!holidayData?.length) return "";
    
    const holidayIds = Array.isArray(holidayData) 
        ? holidayData 
        : holidayData?.toString()?.split(",").sort((a, b) => a - b);
    
    // Check if array contains "No Holiday" marker
    if (holidayIds.includes(-1) || holidayIds.includes("-1")) {
        return "No Holiday";
    }
    
    return holidayIds
        ?.map(day => holidays.find(h => h.id === +day)?.name)
        .filter(Boolean) // Remove undefined values
        .map(h => h.slice(0, 3))
        .join("-");
}

exports.convertToCSV = (data, headers = null, filename = "data.csv") => {
    const csv = jsonToCsv(data, headers);
    downloadCsv(csv, filename);
}

exports.formatHolidays = formatHolidays;
